import { ScoreWithTooltip } from '@/components/ui/ScoreWithTooltip';
import { breakdownFromJob } from '@/lib/jobAdapter';
import { formatSalary } from '@/lib/score';
import type { Job } from '@/types/job.type';

interface TrackerCardProps {
  job: Job;
  onClick: () => void;
}

export const TrackerCard = ({ job, onClick }: TrackerCardProps) => {
  const salary = formatSalary(job.salaryMin, job.salaryMax);
  const breakdown = breakdownFromJob(job);

  return (
    <button
      className="group animate-fadeIn cursor-grab rounded-md border border-border bg-surface px-3 py-2.5 transition-colors hover:border-border-active hover:bg-surface/80 w-full"
      onClick={onClick}
      type="button"
    >
      <div className="flex items-start gap-2.5">
        <ScoreWithTooltip
          breakdown={breakdown}
          score={job.matchScore}
          size="sm"
          style="ring"
        />
        <div className="min-w-0 flex-1 text-left">
          <p className="truncate text-sm/tight lg:text-base/tight font-medium">
            {job.title}
          </p>
          <p className="truncate text-xs lg:text-sm text-foreground-muted">
            {job.company}
          </p>
          <div className="mt-1.5 flex items-center gap-2 text-2xs lg:text-xs text-subtle">
            {salary && (
              <span className="font-mono text-score-high tabular-nums">
                {salary}
              </span>
            )}
            <span className="font-mono tracking-wide uppercase">
              {job.source}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
};
